export default __webpack_public_path__ + "static/media/insta.9eb4a4a0.svg";